import { Button } from '@nextui-org/react'
import React from 'react'
import { Link } from 'react-router-dom'

const DownloadFormat = ({ link }) => {
    return (
        <>
            <Link to={link}>
                <Button color='danger' variant='solid' title='Download File Format!' className='hover:translate-y-[-4px]'>
                    <i className="fa-solid fa-download text-lg"></i>
                </Button>
            </Link>
        </>
    )
}

export default DownloadFormat